import React, { Component } from 'react';
import moment from 'moment';

const styleSelectMonth = {
    height: '25px', 
    width: '60%', 
    padding: '2px',
    fontSize: '11px',
    lineHeight: 1.5,
    borderRadius: '3px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
};

const styleSelectYear = {
    height: '25px', 
    width: '40%', 
    padding: '2px',
    fontSize: '11px',
    lineHeight: 1.5,
    borderRadius: '3px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
};

const w100 = {
    width:'100%'
}

class YearMonthPicker extends Component{
    constructor(props){
        super(props);

        this.state = {
            month: moment().format("M"),
            year: moment().format("YYYY"),
            yearList: []
        };
    }

    handleSelectChange(event){
        const target = event.target;       
		const name = target.name;    
		const value = target.value;
        this.setState(
            {[name]: value},
            () => this.props.onChangeData({month: this.state.month, year: this.state.year})
        );
    }

    componentDidMount(){
        this.setYearList();
    }

    setYearList(){
        let y = moment().format("YYYY");
        let yearList = [];
        let numYearsList = 7;

        for( let i = 0; i < numYearsList; i++ ){
            yearList.push((y-i));
        }

        this.setState({yearList});
    }

    render(){
        return(
            <div className='input-group' style={w100} >
                <select disabled={this.props.disabled} name="month" onChange={this.handleSelectChange.bind(this)} value={this.props.data?this.props.data.month:''} style={styleSelectMonth} className="form-control">
                    <option value="01">Enero</option>
                    <option value="02">Febrero</option>
                    <option value="03">Marzo</option>
                    <option value="04">Abril</option>
                    <option value="05">Mayo</option>
                    <option value="06">Junio</option>
                    <option value="07">Julio</option>
                    <option value="08">Agosto</option>
                    <option value="09">Septiembre</option>
                    <option value="10">Octubre</option>
                    <option value="11">Noviembre</option>
                    <option value="12">Diciembre</option>
                </select>

                <select disabled={this.props.disabled} name="year" onChange={this.handleSelectChange.bind(this)} value={this.props.data?this.props.data.year:''} style={styleSelectYear} className="form-control">
                    {
                        this.state.yearList.map((element, i) => {
                            return <option key={i} value={element}>{element}</option>
                        })
                    }
                </select>
            </div>
        )
    }
}

export default YearMonthPicker;